import { OnInit } from '@angular/core';
import { BackgroundModel } from 'src/app/engine/models/background.model';
import { DomSanitizer } from '@angular/platform-browser';
var SwatchItemComponent = /** @class */ (function () {
    function SwatchItemComponent(domSanitizer) {
        this.domSanitizer = domSanitizer;
        this.size = 'medium';
    }
    Object.defineProperty(SwatchItemComponent.prototype, "isTransparent", {
        get: function () {
            return this.color && BackgroundModel.isTransparent(this.color);
        },
        enumerable: true,
        configurable: true
    });
    SwatchItemComponent.prototype.ngOnInit = function () {
    };
    SwatchItemComponent.prototype.getBackgroundCSS = function () {
        if (this.color && !this.isTransparent) {
            var css = BackgroundModel.toCSS(this.color);
            return this.domSanitizer.bypassSecurityTrustStyle(css);
        }
        else {
            return null;
        }
    };
    return SwatchItemComponent;
}());
export { SwatchItemComponent };
